

import SvgMap from "@/components/Map.vue";
import {ymInitByOrigin} from "@/ym";
import {Component, Vue} from "vue-facing-decorator";
import {getOriginDomain} from "@/utils";
import {setOriginDomain} from "@/api";

@Component({
  components: {
    SvgMap
  }
})
export default class App extends Vue {

  created() {

    console.log('TicketCafe APP created')
    //console.log('process.env=', process.env)

    if (!process.env.VUE_APP_API_URL)
      console.error('env.VUE_APP_API_URL not defined!')

    setOriginDomain(getOriginDomain(this.$route.query))

    ymInitByOrigin(this.$route.query)

  }

  isInIFrame() {
    return (window.top !== window.self) || this.$route.query["debug"]
  }

}

